export default [
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('@/jaas/home/Index.vue'),
    meta: {
      title: '帮代办专区-首页'
    }
  }
]
